import React, { useContext, useEffect, useState } from 'react'

import { getMapTasks, getTasksV3 } from '../queries/query'
import { ModeProvider } from '../context/ModeContext'

export const TaskContext = React.createContext()

export default function TaskContextProvider({ children }) {
    const { lang } = useContext(ModeProvider);
    const limit = 20
    
    const [currentLocation, setCurrentLocation] = useState(null);

    const [type, setType] = useState(null);
    const [filterType, setFilterType] = useState(null);
    const [page, setPage] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [offset, setOffset] = useState(0);
    const [loadPage, setLoadPage] = useState(false);

    const [selectedCols, setSelectedCols] = useState([
        'project_id', 
        'x_studio_nref', 
        'x_studio_many2one_field_Qq4wi', 
        'x_studio_pays_revendiqu', 
        'x_studio_many2many_field_P0OAh', 
        'x_studio_prochaine_chance', 
        'x_studio_certificat_denregistrement_avec_renouvellement', 
        'stage_id', 
        'x_studio_image'
    ]);
    
    const [search, setSearch] = useState('');
    const [countries, setCountries] = useState([]);
    const [typeRight, setTypeRight] = useState([]);
    const [status, setStatus] = useState([]);
    const [classes, setClasses] = useState([]);
    
    const [loading, setLoading] = useState(false);
    const [tasks, setTasks] = useState({});
    const [filter, setFilter] = useState({});

    useEffect(() => {
        if(!loading) {
            console.log('type => ', type)
            if(type === 'tasks') fetchtasks()
            else if(type === 'map') fetchMapTasks()
        }
    }, [lang, currentLocation])

    useEffect(() => {
        if(loadPage){
            setLoadPage(false)
            if(type === 'tasks') fetchtasks('currentPage')
            else if(type === 'map') fetchMapTasks()
        }
    }, [loadPage])
    
    const handleLoading = () => {
        setLoading(true)
    }
    const handleLocation = (value, selectedType) => {
        console.log("selectedType => ", selectedType)
        setType(selectedType)
        // if(!currentLocation) {
        setCurrentLocation(value)
        // }
    }
    const handleSearch = (value) => {
        setSearch(value)
    }
    const handleFilter = (selectedType) => {
        setFilterType(null)
        if(!loading) {
            if(selectedType === 'tasks') fetchtasks()
            else if(selectedType === 'map') fetchMapTasks()
        }
    }
    const handlePagination = (value) => {
        let current = value - 1;
        if(value !== currentPage && value <= page) {
            setOffset(current * limit)
            setCurrentPage(value)
            setLoadPage(true)
        }
    }
    const handleCols = (value) => {
        let newData
        let key = selectedCols.indexOf(value)
        if(key > -1){
            newData = selectedCols.filter(function(item) {
                return item !== value
            })
        }else{
            newData = [...selectedCols, value]
        }
        setSelectedCols(newData)
    }
    const toggleType = (value) => {
        setFilterType(value)
    }
    const changeType = (selectedType) => {
        setType(selectedType)
    }
    const handleControl = (value, type) => {
        let key, newData = null
        
        switch(type){
            case 'type_right':
                key = typeRight.indexOf(value)
                if(key > -1){
                    newData = typeRight.filter(function(item) {
                        return item !== value
                    })
                }else{
                    newData = [...typeRight, value]
                }
                setTypeRight(newData)
                setFilterType(type)
            break;
            case 'countries':
                key = countries.indexOf(value)
                if(key > -1){
                    newData = countries.filter(function(item) {
                        return item !== value
                    })
                }else{
                    newData = [...countries, value]
                }
                setCountries(newData)
                setFilterType(type)
            break;
            case 'classes':
                key = classes.indexOf(value)
                if(key > -1){
                    newData = classes.filter(function(item) {
                        return item !== value
                    })
                }else{
                    newData = [...classes, value]
                }
                setClasses(newData)
                setFilterType(type)
            break;
            case 'status':
                key = status.indexOf(value)
                if(key > -1){
                    newData = status.filter(function(item) {
                        return item !== value
                    })
                }else{
                    newData = [...status, value]
                }
                setStatus(newData)
                setFilterType(type)
            break;
            default: 
                key = null
                setFilterType(null)
            break
        }
    }

    const fetchtasks = async (type = null) => {
        if(currentLocation && currentLocation?.state?.option && currentLocation?.state?.option.length){
            setLoading(true)
            const res = await getTasksV3({
                'child_company': currentLocation?.state?.option,
                'ref': search,
                'country': (countries.length > 0) ? countries : "",
                'type_right': (typeRight.length > 0) ? typeRight : "",
                'status': (status.length > 0) ? status : "",
                'classes': (classes.length > 0) ? classes : "",
                'offset': (type === 'currentPage') ? ((currentPage - 1) * limit) : 0,
                'limit': limit
            });
            if (res.status === true) {
                if(res?.pagination){
                    if(type !== 'currentPage'){
                        setCurrentPage(1)
                        setOffset(0)
                    }
                    setPage(Math.ceil(res?.pagination / limit))
                }
                if(res?.filter){
                    setFilter(res?.filter)
                }
                if(res?.data){
                    setTasks(res?.data)
                }
                setLoading(false)
            } else {
                setLoading(false)
            }
        }
    }
    const fetchMapTasks = async () => {
        if(currentLocation && currentLocation?.state?.option && currentLocation?.state?.option.length){
            setLoading(true)
            const res = await getMapTasks({
                'child_company': currentLocation?.state?.option,
                'ref': search,
                'country': (countries.length > 0) ? countries : "",
                'type_right': (typeRight.length > 0) ? typeRight : "",
                'status': (status.length > 0) ? status : "",
                'classes': (classes.length > 0) ? classes : ""
            });

            if (res.status === true) {
                if(res?.filter){
                    setFilter(res?.filter)
                }
                if(res?.data){
                    setTasks(res?.data)
                }
                setLoading(false)
            } else {
                setLoading(false)
            }
        }
    }

    return (
        <TaskContext.Provider
            value={{
                filterType,
                page,
                currentPage,
                offset,
                loadPage,
                selectedCols,
                search,
                countries,
                typeRight,
                status,
                classes,
                loading,
                tasks,
                filter,
                currentLocation,
                handleLoading,
                handleLocation,
                handleSearch,
                handleFilter,
                handlePagination,
                handleCols,
                toggleType,
                handleControl,
                changeType,
                fetchtasks,
                fetchMapTasks
            }}
        >
            {children}
        </TaskContext.Provider>
    )
}